import { NotificationChannel } from '@frontend/common';
import { FormattedMessage } from 'react-intl';

export const NotificationChannelLabel = (props: { channel: NotificationChannel }) => {
    switch (props.channel) {
        case NotificationChannel.EMAIL:
            return (
                <FormattedMessage
                    id='content-detail.notification-channel.email'
                    description='Display label for the email notification channel'
                    defaultMessage='Email'
                />
            );
        case NotificationChannel.PUSH:
            return (
                <FormattedMessage
                    id='content-detail.notification-channel.push'
                    description='Display label for the push notification channel'
                    defaultMessage='Push'
                />
            );
        case NotificationChannel.SMS:
            return (
                <FormattedMessage
                    id='content-detail.notification-channel.sms'
                    description='Display label for the SMS notification channel'
                    defaultMessage='SMS'
                />
            );
        case NotificationChannel.WHATSAPP:
            return (
                <FormattedMessage
                    id='content-detail.notification-channel.whatsapp'
                    description='Display label for the WhatsApp notification channel'
                    defaultMessage='WhatsApp'
                />
            );
    }
};
